import { useNode } from '@craftjs/core';
import { cn } from '../../../../lib/utils';

interface DividerBlockProps {
  color: string;
  thickness: number;
  style: 'solid' | 'dashed' | 'dotted';
  margin: number;
}

export function DividerBlock({ color, thickness, style, margin }: DividerBlockProps) {
  const {
    connectors: { connect, drag },
    selected,
  } = useNode((state) => ({
    selected: state.events.selected,
  }));

  return (
    <div
      ref={(ref) => {
        if (ref) connect(drag(ref));
      }}
      className={cn(
        'px-2 rounded transition-all',
        selected && 'ring-2 ring-primary ring-offset-2'
      )}
      style={{ marginTop: `${margin}px`, marginBottom: `${margin}px` }}
    >
      <hr
        style={{
          borderColor: color,
          borderTopWidth: `${thickness}px`,
          borderTopStyle: style,
          borderBottom: 'none',
          borderLeft: 'none',
          borderRight: 'none',
        }}
      />
    </div>
  );
}

DividerBlock.craft = {
  displayName: 'Divisor',
  props: {
    color: '#333333',
    thickness: 1,
    style: 'solid' as const,
    margin: 16,
  },
  rules: { canDrag: () => true },
};
